import React, { useEffect } from 'react';
import { Button, Flex, Text } from '@leverege/ui-elements';
import { useWizard } from '@leverege/ui-wizard';
import I18N from '@leverege/i18n';
const {
  t,
  tIcon
} = I18N.ns('pairing.imagine.PairUnpairSelection');
export default function PairUnpairSelection() {
  const {
    context: {
      relationship
    },
    runAction,
    setHeader,
    setHeaderIcon,
    ...rest
  } = useWizard();
  const assetName = relationship.parentBlueprint.name;
  const tagName = relationship.blueprint.name;
  useEffect(() => {
    setHeader(t('header'));
    setHeaderIcon(tIcon('pairIcon'));
  }, []);
  return /*#__PURE__*/React.createElement(Flex, {
    variant: "colL"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "formTitle"
  }, t('title')), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySmall"
  }, t('instruction', {
    tagName,
    assetName
  })), /*#__PURE__*/React.createElement(Button, {
    eventData: "imagine.pairing.SelectAssetPair",
    onClick: runAction,
    variant: "pairOption|primary",
    icon: tIcon('pairIcon')
  }, t('pairAction', {
    assetName,
    tagName
  })), /*#__PURE__*/React.createElement(Button, {
    eventData: "imagine.pairing.SelectUnpair",
    onClick: runAction,
    variant: "unpairOption|secondary",
    icon: tIcon('unpairIcon')
  }, t('unpairAction', {
    assetName,
    tagName
  })));
}
PairUnpairSelection.TYPE = 'imagine.PairUnpairSelection';